/**
 * requestAnimationFrame loop with a clamped delta, so a backgrounded tab does
 * not resume with a multi-second step. Callbacks receive (dt, elapsed) seconds.
 */
export function createLoop(update) {
  const MAX_DT = 1 / 15;
  let rafId = null;
  let last = 0;
  let elapsed = 0;

  function frame(now) {
    rafId = requestAnimationFrame(frame);
    const dt = Math.min((now - last) / 1000, MAX_DT);
    last = now;
    elapsed += dt;
    update(dt, elapsed);
  }

  return {
    start() {
      if (rafId !== null) return;
      last = performance.now();
      rafId = requestAnimationFrame(frame);
    },
    stop() {
      if (rafId === null) return;
      cancelAnimationFrame(rafId);
      rafId = null;
    },
  };
}
